import styled from 'styled-components';
import { COLORS, breakPoint } from '@ertelecom/ui-react/assets/js/constants';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';

export const Wrapper = styled.div`
  background: ${COLORS.white};
  box-shadow: 0 6px 12px;
  border-radius: 8px;
  border: 1px solid ${COLORS.outlineGrey};
  color: transparent;
  display: flex;
  flex-direction: column;
  transition: 0.3s ease color;
  overflow: hidden;

  &:hover {
    color: rgba(0, 0, 0, 0.07);
  }
`;

export const Header = styled.div`
    background-color: ${COLORS.lightRed};
    display: flex;
    flex-shrink: 0;
    flex-grow: 1;
    flex-wrap: wrap;
    padding: 20px;
    justify-content: flex-end;
    justify-content: space-between;

    @media(${breakPoint(1024)}) {
        flex-direction: column;
        padding-top: 5px;
    }

    @media(${breakPoint(320)}) {
        padding-top: 10px;
        padding-bottom: 24px;
    }
`;

export const HeaderWrapper = styled.div`
    display: block;
    flex-shrink: 0;
    max-width: 100%;
`;

export const Title = styled.div`
    font: 400 20px/28px "Roboto", sans-serif;
    color: ${COLORS.white};
    margin-top: 5px;

    @media(${breakPoint(1024)}) {
        margin-top: 0;
    }
`;

export const InfoWrapper = styled.div`
    flex-shrink: 0;
    display: flex;
    flex-direction: ${props => props.longDesktop ? 'row' : 'column'};
    align-items: ${props => props.longDesktop ? 'center' : 'flex-end'};
    justify-content: ${props => props.longDesktop ? 'space-between' : ''};
    width: ${props => props.longDesktop ? '100%' : ''};

    @media(${breakPoint(1366)}) {
        flex-direction: ${props => props.longDesktopSmall ? 'row' : 'column'};
        align-items: ${props => props.longDesktopSmall ? 'center' : 'flex-end'};
        justify-content: ${props => props.longDesktopSmall ? 'space-between' : ''};
        width: ${props => props.longDesktopSmall ? '100%' : ''};
    }

    @media(${breakPoint(1024)}) {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top: 42px;
        width: 100%;
    }

    @media(${breakPoint(320)}) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const Pause = styled.div`
    align-items: center;
    background-color: ${COLORS.white};
    border-radius: 20px;
    color: ${COLORS.black};
    font: 400 14px/1em "Roboto", sans-serif;
    display: flex;
    justify-content: center;
    height: 20px;
    padding: 0 8px;
    margin-top: 6px;

    @media(${breakPoint(1024)}) {
        margin-top: 0;
    }

    @media(${breakPoint(320)}) {
        margin-top: 5px;
    }
`;

export const Description = styled.div`
    font: 400 16px/24px "Roboto", sans-serif;
    color: ${COLORS.white};
    margin-top: 2px;
`;

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 28px 20px;

    @media(${breakPoint(1366)}) {
        padding-top: 17px;
        padding-bottom: 17px;
    }

    @media(${breakPoint(1024)}) {
        padding-top: 20px;
        padding-bottom: 20px;
    }
`;

export const Button = styled(StyledButton)`
    flex-shrink: 0;
    width: auto;

    @media(${breakPoint(1366)}) {
        flex-grow: 1;
    }

    @media(${breakPoint(1024)}) {
        width: 100%;
    }

    & + & {
        margin-left: 19px;

        @media(${breakPoint(1366)}) {
            margin-left: 20px;
        }

        @media(${breakPoint(1024)}) {
            margin-top: 15px;
            margin-left: 0;
        }
    }
`;
